<template>
  <header class="pt-5 header">
    <div class="container max-w-5xl mx-auto">
      <div class="ie-hero-heading flex flex-col items-center mt-2 mb-2 sm:flex-row jusitfy-between md:mb-6">
        <div class="w-6/6 sm:w-auto md:w-3/6 lg:w-2/6">
        <Logo alt="Post Office Credit Card QuickCheck" class="inline-block w-16 mr-5 h-14"></Logo>
          <span class="text-xl font-semibold align-text-middle">Credit Card QuickCheck</span>
        </div>
        <div class="inline-flex mt-2 mb-3"> </div>
      </div>
      <main class="pt-4 pb-8">
        <h1 class="mb-4 text-2xl font-semibold text-center">Unfortunately, based on the information you've provided</h1>
        <h2 class="mb-4 text-5xl font-bold leading-none text-center">We are unable to offer you a Post Office Credit Card at this time</h2>
        <p class="text-xl font-medium leading-tight text-center">One factor we look at when deciding whether we can offer you a Credit Card is your credit score. Your credit score is a sign of your financial health, while your credit report goes into the detail of the last 6 years of your credit history. A credit rating is a way of showing your chances of being approved for credit.</p>
        <br>
        <p class="text-xl font-medium leading-tight text-center">We may use data from <a href="https://www.equifax.co.uk/" target="_blank">Equifax</a>, <a href="https://www.transunion.co.uk/crain" target="_blank">Transunion</a> and <a href="https://www.experian.co.uk/" target="_blank">Experian</a> to decide if we can lend to you, so it's important this information is correct. You can sign up with them to check your details (some may charge a fee).</p>
      </main>
    </div>
  </header>
</template>

<script>

// svgs
import Logo from '@/v2/assets/images/logos/post-office.svg';

export default {
  name: 'Header',
  data(){
    return {
      header: {
        
      }
    }
  },
  components: {
    Logo
  }
}
</script>
